<template>
    <div>
        <div class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24">
            <h3
                class="text-2xl lg:text-5xl text-primary font-semibold tracking-wide mb-16"
            >
                {{ terms.Title }}
            </h3>
            <rich-text :text="terms.Description" />
        </div>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const { data: terms } = await useFetch(
    config.public.baseURl + '/terms-and-conditions'
);
useHead({
    title: 'Terms and conditions',
});
</script>

<style lang="scss" scoped></style>
